import api from '../api'

export default {
  async loadList (context) {
    api.account.listAll().then((response) => {
      context.commit('listCommit', response)
    })
  },
  loadListByNetwork (context, payload) {
    return api.account.list(payload)
  },
  loadByParent (context, parentId) {
    return api.account.list({
      parent_id: parentId
    })
  }
}
